import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from "vue";
import { serviceRegion } from "@/const/service/init";
import FlagIcon from "@/components/toolbar/language/FlagIcon.vue";
import store from "@/store";
import { DataLanguage } from "@/store/modules/data-language";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarDataLanguage',
  props: {
    showArrow: { type: Boolean },
    showLabel: { type: Boolean }
  },
  setup(__props: any) {


const availableLocales = computed((): DataLanguage[] =>
  serviceRegion.getDataLanguages(),
);

// TODO joony: 임시배포 처리::다언어 데이터지원
// function setDataLanguages(locale: DataLanguage) {
//   store.commit("setDataLanguage", locale);
//   location.reload();
// }

onMounted(() => {
  if (!store.getters.dataLanguage) {
    store.commit("setDataLanguage", availableLocales.value?.[0]);
  }
});

return { __sfc: true,availableLocales, FlagIcon, store }
}

})